import { MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { type LensStatsModel } from "../models";

import { extractLensStatValue } from "./extractLensStatValue";

export const mapLensStats = (
    responseEntryList: readonly MyLensesOrganicStatsResponseEntry[],
    stats: LensStatsModel,
): LensStatsModel => {
    if (stats[MetricField.LensViews]) {
        stats[MetricField.LensViews].value = extractLensStatValue(responseEntryList, MetricField.LensViews);
    }
    if (stats[MetricField.LensShares]) {
        stats[MetricField.LensShares].value = extractLensStatValue(responseEntryList, MetricField.LensShares);
    }
    if (stats[MetricField.LensPlays]) {
        stats[MetricField.LensPlays].value = extractLensStatValue(responseEntryList, MetricField.LensPlays);
    }
    return stats;
};
